import { useEffect } from "react"
import { useAudios } from "../../assets/useAudios"
import Bell from '../../images/animations/Bell.gif'

import './InterludeAnimation.css'

const InterludeAnimation = (props) => {
    const audio = useAudios()

    useEffect(() => {
        audio.setAndPlay('gong')
        //eslint-disable-next-line
    }, [])

    if (!props.showInterludeAnimation) return null

    return (
        <div className='interlude-container'>
            <img className='interlude-bell' src={Bell} alt='Pelikello' />
            <div className='interlude-message'>{props.message}</div>
            </div>
    )
}

export default InterludeAnimation